module.exports = __webpack_public_path__ + "static/media/soy copy 3.9efd70b9.png";